import styles from './Progress.module.css';

interface ProgressRingProps {
  /** 0–100. Кольцо — единственное разрешённое «круглое» состояние загрузки,
      и только с настоящим процентом с сервера (DESIGN_SYSTEM §5.9). */
  percent: number;
  /** Подпись под числом («abgeschlossen»). */
  label: string;
  /** Доступное имя процесса. */
  title: string;
  size?: number | undefined;
  className?: string | undefined;
}

const STROKE = 8;

/** Кольцо прогресса анализа (референс `screen3`, правая панель). */
export function ProgressRing({ percent, label, title, size = 112, className }: ProgressRingProps) {
  const bounded = Math.max(0, Math.min(100, Math.round(percent)));
  const radius = (size - STROKE) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = (bounded / 100) * circumference;

  return (
    <div
      className={[styles.ring, className].filter(Boolean).join(' ')}
      role="progressbar"
      aria-label={title}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={bounded}
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <circle
          className={styles.ringTrack}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={STROKE}
          fill="none"
        />
        <circle
          className={styles.ringValue}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={STROKE}
          strokeLinecap="round"
          fill="none"
          strokeDasharray={`${dash} ${circumference - dash}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <span className={styles.ringCenter}>
        <span className={`${styles.ringNumber} tabular`}>{bounded} %</span>
        <span className={styles.ringLabel}>{label}</span>
      </span>
    </div>
  );
}
